/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserShortInfo} from '../models/UserShortInfo';

export interface GetAdminShortInfo$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAdminShortInfoRequest = createAction<PayloadData<void>>('GET_ADMIN_SHORT_INFO__GET_ADMIN_SHORT_INFO__REQUEST');
export const getAdminShortInfoSuccess = createAction<PayloadData<UserShortInfo>>('GET_ADMIN_SHORT_INFO__GET_ADMIN_SHORT_INFO__SUCCESS');
export const getAdminShortInfoFailure = createAction<PayloadData<Error, void, true>>('GET_ADMIN_SHORT_INFO__GET_ADMIN_SHORT_INFO__FAILURE');

export const getAdminShortInfoActions = [
    getAdminShortInfoRequest,
    getAdminShortInfoSuccess,
    getAdminShortInfoFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAdminShortInfo = (config?: GetAdminShortInfo$Config) => {
    return {
        CALL_API: {
            types: getAdminShortInfoActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/admins`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

